<template>
  <div class="m-not-found">
    <h1>{{ $t('mNotFound.title.first') }}</h1>
    <h3>{{ $t('mNotFound.title.second') }}</h3>
    <router-link
      class="text-color-academy-primary text-weight-bold"
      :to="{ name: 'home' }"
    >
      {{ $t('mNotFound.link') }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'MoleculeNotFound'
}
</script>
